import { IDictionary } from '~utilities/IDictionary';
import AccountTypeEnum from './AccountTypeEnum';

const accountTypeLabels: IDictionary<string> = {
    [AccountTypeEnum.IncomeTrust]: 'Income Trust',
    [AccountTypeEnum.Marketplace]: 'Marketplace',
};

export default accountTypeLabels;